import {createLogger} from '@alwatr/logger';


export const logger = /* #__PURE__ */ createLogger(__package_name__);
